/* globals axios */

import Vue from 'vue';
import Errors from '../classes/Errors';

Vue.component('form-component', {
    props: {},

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            errors: new Errors(),
            formCompleted: false,
            submitting: false,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {},

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        onSubmit(event) {
            if (this.formCompleted) {
                return;
            }

            const form = event.currentTarget;

            if (this.submitting) {
                return;
            }

            this.submitting = true;

            axios
                .post('/', new FormData(form))
                .then((response) => {
                    this.submitting = false;
                    const result = response.data;

                    if (result && result.data && result.data.errors) {
                        this.errors.clear();
                        this.errors.record(result.data.errors);

                        return;
                    }

                    // Success
                    this.formCompleted = true;
                    this.errors.clear();
                // this.scrollToTop();
                })
                .catch((error) => {
                    this.submitting = false;
                    console.log(error.response);
                });
        },
    },
});
